import React from 'react'
import { Badge } from '@/shared/components/ui/badge'

interface AccountHeaderProps {
    title: string
    description: string
    userId?: string
}

export const AccountHeader: React.FC<AccountHeaderProps> = ({ title, description, userId }) => {
    return (
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-border pb-6">
            <div>
                <h1 className="text-3xl font-bold tracking-tight text-foreground">
                    {title}
                </h1>
                <p className="text-muted-foreground mt-1 text-sm">
                    {description}
                </p>
            </div>
            {userId && (
                <Badge variant="outline" className="w-fit text-xs font-medium text-muted-foreground px-2 py-0.5">
                    ID: {userId.slice(0, 8)}...
                </Badge>
            )}
        </div>
    )
}
